import React from 'react';
import Cookies from 'js-cookie';
import moment from 'moment';
import { Component } from 'react';
import { connect } from 'react-redux';
import image1 from '../../assets/images/1.jpg';
import image2 from '../../assets/images/2.jpg';
import {
  clearSelectedPatient,
  getCurvesList,
  getPatientDetails,
  getSettings,
  navigateTo,
  openModal,
  requestResetPasswrod,
  saveAllDiagnostics,
  setDiagnosis,
  setError,
  setNewPass,
  setSettings,
} from '../../redux/actions';
import { colors, patientDetailsStyles } from '../../theme/style';
import { isLoggedInis, parseJwt, statusTypes } from '../../utils/CFuncs';
import { modalNames, roles, urls } from '../../utils/Objects';
import { Loading } from '../common';
import Alerts from '../common/Alerts';
import MyLink from '../common/MyLink';
import BackToPage from '../common/back-to-page';
import Compliance from '../common/compliance';
import AdminLayout from '../user/admin/AdminLayout';
import DiagnosisModal from './Details/DiagnosisModal';
import DiagnosticSelector from './Details/DiagnosticSelector';
import Diagnostics from './Details/Diagnostics';
import Goal from './Details/Goal';
import PasswordModal from './Details/PasswordModal';
import PersonalInfo from './Details/PersonalInfo';

class PatientDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isResetButtonEnabled: true,
      image: null,
      timeframe: '',
      open: false,
      chartData: [],
      goal: 0,
      info: false,
      diagnose: 0,
      pass: false,
      newPass: '',
      newImage: null,
      newDiagnosis: {
        apexidentifier: '',
        curveDirection: '',
        cobbAngle: '',
        rotationAngle: '',
      },
    };
    this.updateIsResetButtonEnabled = this.updateIsResetButtonEnabled.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.handleDiagnosisChange = this.handleDiagnosisChange.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.saveDiagnosis = this.saveDiagnosis.bind(this);
    this.handleUpdateInfo = this.handleUpdateInfo.bind(this);
    this.handleNewPassChange = this.handleNewPassChange.bind(this);
    this.handlePassChange = this.handlePassChange.bind(this);
    this.handleChangeGoal = this.handleChangeGoal.bind(this);
    this.hasAccess = this.hasAccess.bind(this);
    this.resetDiagnosis = this.resetDiagnosis.bind(this);
    this.updateDiagnosInd = this.updateDiagnosInd.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.user.patient !== this.props.user.patient) {
      const patient = this.props.user.patient;
      this.setState({
        goal: patient.settings.complianceHours,
      });
    }
  }
  componentDidMount() {
    this.getDetails();
  }
  getDetails() {
    let id = this.props.selectedPatient?.id;
    this.props.getPatientDetails(id);
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleOpen = () => {
    this.setState({ open: true });
  };
  updateIsResetButtonEnabled = () => {
    this.setState({ isResetButtonEnabled: true });
  };

  updateDiagnosInd = (diagnose) => {
    this.setState({
      diagnose,
    });
  };
  handleDiagnosisChange = (name, value) => {
    this.setState({
      newDiagnosis: {
        ...this.state.newDiagnosis,
        [name]: value,
      },
    });
  };
  handleImageChange = (newImage) => {
    this.setState({
      newImage,
    });
  };

  validateDiagnoses = () => {
    try {
      let vals = Object.values(this.state.newDiagnosis);
      let isDiagnosis = vals.reduce((acc, name) => acc + (name == '' ? 0 : 1), 0) === vals.length;
      if (!isDiagnosis) {
        this.props.setError('You have to set all fields');
        return false;
      }
 
      return true;
    } catch (err) {
      console.log(err);
    }
  };
  resetDiagnosis = () => {
    this.setState({
      newDiagnosis: {
        apexidentifier: '',
        curveDirection: '',
        cobbAngle: '',
        rotationAngle: '',
      },
      newImage: null,
    });
  };
  saveDiagnosis = () => {
    console.log(this.state.newImage);
    console.log(this.props.patient);
    console.log(this.props.patient.personalInfo);
    if (this.validateDiagnoses()) {
      this.props.saveAllDiagnostics(this.props.patient.personalInfo.id, this.state.newDiagnosis, this.state.newImage, this.resetDiagnosis);
    }
  };

  handleUpdateInfo = (info) => {
    this.setState({ info });
  };

  handleNewPassChange = (newPass) => {
    this.setState({ newPass });
  };
  handlePassChange = (pass) => {
    this.setState({ pass });
  };
  handleChangeGoal = (goal) => {
    this.setState({ goal });
  };

  hasAccessToReset = () => {
    const token = Cookies.get('auth');
    const user = parseJwt(token);
    const isAdmin = user.roles === roles.Administrator;
    return isAdmin;
  };

  resetPassword = () => {
    if (!this.state.isResetButtonEnabled) {
      return;
    }
    const email = this.props.user.patient?.peronalInfo?.email;
    this.props.requestResetPasswrod(email, this.updateIsResetButtonEnabled, this.updateIsResetButtonEnabled);
    this.setState({ isResetButtonEnabled: false });
  };

  isPaitentLogin = () => {
    const token = Cookies.get('auth');
    const data = parseJwt(token);
    return data.roles.includes(roles.Patient);
  };
  hasAccess = () => {
    return isLoggedInis(roles.Administrator) || isLoggedInis(roles.HealthCareProvider);
  };

  render() {
    console.log(this.props.user.patient?.settings?.complianceHours);
    const patient = this.props.user.patient;
    let compilance;

    if (patient) {
      compilance = patient?.settings?.complianceHours ? Number(patient?.settings?.complianceHours) : 0;
      // diagnose = patient.diagnosis ? patient.diagnosis : [];
    }
    return (
      <AdminLayout {...this.props}>
        <div>
          {!patient && <Loading />}
          <Alerts />
          {patient && (
            <section style={patientDetailsStyles.container}>
              <div style={patientDetailsStyles.flexContainer}>
                {!isLoggedInis(roles.Patient) && <BackToPage link={urls.patients} text="Patient List" />}
                {isLoggedInis(roles.Patient) && (
                  <div style={patientDetailsStyles.message}>If you want to add your data , you can loggIn into your app</div>
                )}
              </div>
              <div className="row" style={{ marginLeft: 20 }}>
                {/* 1st */}
                <PersonalInfo
                  peronalInfo={patient.personalInfo}
                  picList={picList}
                  handleUpdateInfo={this.handleUpdateInfo}
                  info={this.state.info}
                  settings={patient.settings}
                  diagnoseInd={this.state.diagnose}
                />

                {/* 2nd */}
                <div style={{ marginLeft: 30, marginRight: 30 }}>
                  {/* <div onClick={() => { this.setState({ pass: true }) }} style={styles.button}>Change Password</div> */}
                  {this.hasAccessToReset() && (
                    <div>
                      <button style={this.state.isResetButtonEnabled ? styles.buttonRed : styles.buttonGray} onClick={this.resetPassword}>
                        reset password
                      </button>
                      <div style={styles.error}>{this.props.login.error}</div>
                      <div style={styles.success}>{this.props.user.succesMessage}</div>
                    </div>
                  )}
                  <PasswordModal
                    newPass={this.state.newPass}
                    handleNewPassChange={this.handleNewPassChange}
                    handlePassChange={this.handlePassChange}
                    pass={this.state.pass}
                  />
                  {/* Diagnosis */}
                  <DiagnosticSelector index={this.state.diagnose} updateDiagnosInd={this.updateDiagnosInd} />
                  <div />
                  <div>
                    <Diagnostics index={this.state.diagnose} diagnosis={patient.diagnosis} diagnoseLoading={this.props.diagnoseLoading} />
                  </div>
                  <div />

                  {this.hasAccess() && (
                    <div
                      onClick={() => {
                        this.props.openModal(modalNames.Diagnosis);
                      }}
                      style={styles.button}
                    >
                      Add New Diagnosis
                    </div>
                  )}

                  <DiagnosisModal
                    newImage={this.state.newImage}
                    handleImageChange={this.handleImageChange}
                    onDiagnosisChange={this.handleDiagnosisChange}
                    newDiagnosis={this.state.newDiagnosis}
                    saveDiagnosis={this.saveDiagnosis}
                  />
                </div>
                {/* 3rd */}
                <div>
                  <div className="row">
                    {/* Treatment */}
                    <div>
                      <div style={patientDetailsStyles.startDate}>Start Date &nbsp;</div>
                      <span>{moment('2015-10-30').format('MMM D, YYYY')}</span>
                    </div>

                    {/* Status */}
                    <div style={{ marginLeft: 15, marginRight: 15 }}>
                      <div style={patientDetailsStyles.startDate}>Patient Status &nbsp;</div>
                      <div>{statusTypes[patient?.personalInfo?.status]}</div>
                      {this.hasAccess() && (
                        <MyLink
                          pathname={urls.patientStatus}
                          state={{
                            user: this.props.selectedPatient,
                            prevPage: urls.patientDetails,
                          }}
                        >
                          Change Status
                        </MyLink>
                      )}
                    </div>

                    {/* Goal */}
                    <Goal goal={this.state.goal} handleChangeGoal={this.handleChangeGoal} compilance={compilance} hasAccess={this.hasAccess} />
                  </div>

                  {/* Compilance */}
                  <div>
                    {patient.compilanceList ? (
                      <div>
                        <Compliance
                          onFetchChartData={() => {}}
                          physicalActivity={{
                            browseDailyPending: false,
                            browseDaily: patient.compilanceList,
                          }}
                          // goal={Number(patient.settings.complianceHours || 0)}
                          goal={Number(compilance) || 0}
                          style={patientDetailsStyles.compliance}
                        />
                      </div>
                    ) : (
                      <div>No Compilance Hours</div>
                    )}
                  </div>
                </div>
              </div>
            </section>
          )}
        </div>
      </AdminLayout>
    );
  }
}

const button = {
  cursor: 'pointer',
  backgroundColor: '#4CAF50',
  border: 'none',
  color: 'white',
  padding: 7,
  textAlign: 'center',
  textDecoration: 'none',
  display: 'inline-block',
  fontSize: 16,
  userSelect: 'none',
};
const picList = [image1, image2];
const styles = {
  centerModal: {
    width: 600,
    height: 600,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  buttonGray: {
    ...button,
    marginTop: '5rem',
    backgroundColor: '#605959',
  },
  container: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    // border: '1px solid'
  },
  insideContainer: {
    display: 'flex',
    flexDirection: 'column',
    // border: '1px solid'
  },
  title: {
    position: 'relative',
    top: -50,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  passTitle: {
    position: 'relative',
    top: -20,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 40,
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },

  button,
  buttonDisabled: {
    cursor: 'pointer',
    backgroundColor: '#9f9f9f',
    border: 'none',
    color: 'white',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScroll: {
    cursor: 'pointer',
    border: 'none',
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    fontWeight: 'bold',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonScrollNoMore: {
    cursor: 'pointer',
    border: 'none',
    color: colors.purpleGrey,
    padding: 7,
    textAlign: 'center',
    textDecoration: 'none',
    display: 'inline-block',
    fontSize: 16,
    userSelect: 'none',
  },
  buttonGreen: {
    ...button,
    backgroundColor: '#4CAF50',
  },
  buttonRed: {
    ...button,
    marginTop: '5rem',
    backgroundColor: '#ea0404',
  },
  error: {
    color: '#ea0404',
  },
  success: {
    color: '#4CAF50',
  },
};

const mapStateToProps = (state, ownProps) => {
  const selectedPatient = ownProps.location.state?.patient;
  console.log('selectedPatient Details =>  ', selectedPatient);
  return {
    login: state.login,
    user: state.user,
    patient: state.user.patient,
    clinic: state.clinic,
    diagnoseLoading: state.user.diagnoseLoading,
    selectedPatient: selectedPatient ?? state.user.selectedPatient,
    // selectedPatient: ownProps.location.state.item ?? selectedPatient
  };
};

const mapDispatchToProps = {
  navigateTo,
  getCurvesList,
  getSettings,
  getPatientDetails,
  setSettings,
  setDiagnosis,
  setNewPass,
  clearSelectedPatient,
  requestResetPasswrod,
  openModal,
  setError,
  saveAllDiagnostics,
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientDetails);
